var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogVisible)?_c('el-image-viewer',{attrs:{"on-close":_vm.closeViewer,"url-list":_vm.imageList}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }